import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export const required = (value: string) => (!!value ? undefined : 'Required');
export const mustBeChecked = (value: boolean) => (value ? undefined : 'Required');
export const arrayNotEmpty = (value: any[]) =>
  value.length > 0 ? undefined : 'Must have at least one debt listed.';

export const decimal = (value: string) =>
  value === undefined || /^[0-9]+(\.[0-9]{1,2})?$/i.test(value)
    ? undefined
    : 'Must be a non-negative dollar amount';

export const fourDigits = (value: string) => {
  if (value === undefined) {
    return undefined;
  } else {
    return value.length === 4 && Number(value) >= 0
      ? undefined
      : 'Value must be a 4 digit positive number';
  }
};
export const fullSsn = (value: string) =>
  !value || value.match(/^\d{3}-?\d{2}-?\d{4}$/) ?
    undefined : 'Value must be a valid SSN';

export const nonNegative = (value: string) => {
  if (value === undefined) {
    return undefined;
  } else {
    return Number(value) >= 0 ? undefined : 'Value cannot be negative';
  }
};

export const fiveDaysFuture = (value: string) => {
  if (!!value) {
    const daysDifference = differenceInCalendarDays(new Date(value), new Date());
    return daysDifference < 5 ? 'Must be at least 5 full days in the future' : undefined;
  }
};
